module.exports = __webpack_public_path__ + "static/media/Article1.fe8dd838.webp";